<template>
   <div class="goods-tabs-body-product">
        <div class="goods-tabs-body-product-box">
            <div class="goods-tabs-body-product-img" v-for="(item,index) in goods.list" :class="{goodsTabsBodyProductImgLeft:index%3==2}">
                
                <video v-if="item.type=='mp4'" :src="item.imgurl" controls="controls"></video>
                
                <img v-if="item.type!='mp4'" :src="item.imgurl">
                <p>{{item.title}}</p>
            </div>
            <!-- <div class="goods-tabs-body-product-img">
                <img src="@/assets/common/images/ceshi1.png">
                <p>工业机器人</p>
            </div>
            <div class="goods-tabs-body-product-img goods-tabs-body-product-img-left">
                <img src="@/assets/common/images/ceshi1.png">
                <p>工业机器人</p>
            </div>
            <div class="goods-tabs-body-product-img">
                <img src="@/assets/common/images/ceshi1.png">
                <p>工业机器人</p>
            </div>
            <div class="goods-tabs-body-product-img">
                <img src="@/assets/common/images/ceshi1.png">
                <p>工业机器人</p>
            </div> -->
        </div>                    
    </div>
</template>

<script>
export default {
    props:['goods']
}
</script>

<style>
    .goods-tabs-body-product{
        padding: 40px 70px;
        background-color: #fff;
    }
    .goods-tabs-body-product-box{
         width: 100%;
         overflow: hidden;
    }
    .goods-tabs-body-product .goods-tabs-body-product-img{
        width: 325px;
        float: left;
        margin-right: 42px;
        text-align: center;
        margin-bottom: 30px;
    }
    .goods-tabs-body-product .goods-tabs-body-product-img img{
        width: 100%;
        margin-bottom: 15px;
    }
    .goods-tabs-body-product .goods-tabs-body-product-img video{
        width: 100%;
        margin-bottom: 15px;
        height: 211px;
    }
    .goods-tabs-body-product .goodsTabsBodyProductImgLeft{
        margin-right: 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/goods/GoodsProduct.vue